import { sanitizeFilename } from "../sanitizeFilename";

export function difficultyBalancerToPptDocument(result) {
  const slides = [
    {
      kind: "title",
      title: result.title,
      subtitle: result.curriculumLabel,
    },
    {
      kind: "bullets",
      title: "Bloom's Level Audit",
      bullets: [
        result.bloomsAudit.summary,
        ...result.bloomsAudit.levels.map(
          (level) => `${level.level}: ${level.count} questions (${level.percent}%)`,
        ),
        ...result.bloomsAudit.recommendations,
      ],
    },
  ];

  if (result.balanceSummary) {
    slides.push({
      kind: "section",
      title: "Balance Summary",
      body: result.balanceSummary,
    });
  }

  if (result.sampleQuestions?.length > 0) {
    slides.push({
      kind: "bullets",
      title: "Sample Balanced Questions",
      bullets: result.sampleQuestions.map(
        (item) => `[${item.bloomLevel}] ${item.question} — ${item.rationale}`,
      ),
    });
  }

  return {
    filename: sanitizeFilename(`${result.topicLabel} difficulty-balance`, "difficulty-balancer"),
    title: result.title,
    subject: result.curriculumLabel,
    author: "Tema Adjust Question Difficulty",
    slides,
  };
}
